export var AnalyticsEventType = /*#__PURE__*/function (AnalyticsEventType) {
  /**
   * User was sent a renewal email
   */
  AnalyticsEventType[AnalyticsEventType["RENEWAL_EMAIL_SENT"] = 1] = "RENEWAL_EMAIL_SENT";
  /**
   * Support agent awarded free months to the user
   */
  AnalyticsEventType[AnalyticsEventType["GIVEN_FREE_MONTHS"] = 2] = "GIVEN_FREE_MONTHS";
  /**
   * User was sent an item delivered email
   */
  AnalyticsEventType[AnalyticsEventType["ITEM_DELIVERED_EMAIL_SENT"] = 3] = "ITEM_DELIVERED_EMAIL_SENT";
  /**
   * User entered anonymous mode
   */
  AnalyticsEventType[AnalyticsEventType["ENTER_ANONYMOUS_MODE"] = 4] = "ENTER_ANONYMOUS_MODE";
  /**
   * User exited anonymous mode
   */
  AnalyticsEventType[AnalyticsEventType["EXIT_ANONYMOUS_MODE"] = 5] = "EXIT_ANONYMOUS_MODE";
  /**
   * User was sent an email confirming free months were applied to her account
   */
  AnalyticsEventType[AnalyticsEventType["FREE_MONTHS_APPLIED_EMAIL_SENT"] = 6] = "FREE_MONTHS_APPLIED_EMAIL_SENT";
  /**
   * User was sent a discount by customer support
   */
  AnalyticsEventType[AnalyticsEventType["GIVEN_DISCOUNT_BY_CS"] = 7] = "GIVEN_DISCOUNT_BY_CS";
  /**
   * User has been created a subscription by customer support
   */
  AnalyticsEventType[AnalyticsEventType["SUBSCRIPTION_CREATED_BY_CS"] = 8] = "SUBSCRIPTION_CREATED_BY_CS";
  /**
   * User successfully updated T3 firmware. The event is sent from the app.
   */
  AnalyticsEventType[AnalyticsEventType["T3_FOTA_SUCCEEDED"] = 9] = "T3_FOTA_SUCCEEDED";
  /**
   * User failed to update T3 firmware. The event is sent from the app.
   */
  AnalyticsEventType[AnalyticsEventType["T3_FOTA_FAILED"] = 10] = "T3_FOTA_FAILED";
  /**
   * Subscription has had its sales tax addOn recalculated.
   */
  AnalyticsEventType[AnalyticsEventType["SUBSCRIPTION_SALES_TAX_RECALCULATION"] = 11] = "SUBSCRIPTION_SALES_TAX_RECALCULATION";
  return AnalyticsEventType;
}(AnalyticsEventType || {});
/**
 * This field is set when CS agent gives additional months via Admin3 or when the user is given free months as reward for referring a friend.
 */
export var MonthsAdditionReason = /*#__PURE__*/function (MonthsAdditionReason) {
  MonthsAdditionReason[MonthsAdditionReason["BUG"] = 1] = "BUG";
  MonthsAdditionReason[MonthsAdditionReason["COMPENSATION"] = 2] = "COMPENSATION";
  MonthsAdditionReason[MonthsAdditionReason["DELAYED_DELIVERY"] = 3] = "DELAYED_DELIVERY";
  MonthsAdditionReason[MonthsAdditionReason["PREGNANCY_MONTHS"] = 4] = "PREGNANCY_MONTHS";
  MonthsAdditionReason[MonthsAdditionReason["PROBLEMS_WITH_PAYMENT"] = 5] = "PROBLEMS_WITH_PAYMENT";
  MonthsAdditionReason[MonthsAdditionReason["RETURN_USER_SAVED_SUBSCRIPTION"] = 6] = "RETURN_USER_SAVED_SUBSCRIPTION";
  MonthsAdditionReason[MonthsAdditionReason["OTHER"] = 7] = "OTHER";
  MonthsAdditionReason[MonthsAdditionReason["PREGNANCY_RELATED_SUBSCRIPTION_FREEZE"] = 8] = "PREGNANCY_RELATED_SUBSCRIPTION_FREEZE";
  MonthsAdditionReason[MonthsAdditionReason["SEX_CHALLENGE_SUBSCRIPTION_FREEZE"] = 9] = "SEX_CHALLENGE_SUBSCRIPTION_FREEZE";
  MonthsAdditionReason[MonthsAdditionReason["PHARMACY_CODE"] = 10] = "PHARMACY_CODE";
  MonthsAdditionReason[MonthsAdditionReason["PROBLEMS_WITH_THERM"] = 11] = "PROBLEMS_WITH_THERM";
  MonthsAdditionReason[MonthsAdditionReason["FAULTY_PRODUCT"] = 12] = "FAULTY_PRODUCT";
  MonthsAdditionReason[MonthsAdditionReason["UNHAPPY_WITH_DATA"] = 13] = "UNHAPPY_WITH_DATA";
  MonthsAdditionReason[MonthsAdditionReason["DELAYING_START_DATE"] = 14] = "DELAYING_START_DATE";
  MonthsAdditionReason[MonthsAdditionReason["OURA_FREE_TRIAL"] = 15] = "OURA_FREE_TRIAL";
  MonthsAdditionReason[MonthsAdditionReason["MARKETING_INFLUENCER"] = 16] = "MARKETING_INFLUENCER";
  MonthsAdditionReason[MonthsAdditionReason["RAF_REWARD"] = 17] = "RAF_REWARD";
  return MonthsAdditionReason;
}(MonthsAdditionReason || {});
/**
 * This field is set when CS agent creates a paid subscription on behalf of the user from Admin3.
 */
export var SubscriptionCreatedByCSReason = /*#__PURE__*/function (SubscriptionCreatedByCSReason) {
  SubscriptionCreatedByCSReason[SubscriptionCreatedByCSReason["ISSUES_WITH_PAYMENT_METHOD"] = 1] = "ISSUES_WITH_PAYMENT_METHOD";
  SubscriptionCreatedByCSReason[SubscriptionCreatedByCSReason["SUBSCRIPTION_PRICING"] = 2] = "SUBSCRIPTION_PRICING";
  SubscriptionCreatedByCSReason[SubscriptionCreatedByCSReason["ISSUE_SELECTING_CURRENCY"] = 3] = "ISSUE_SELECTING_CURRENCY";
  return SubscriptionCreatedByCSReason;
}(SubscriptionCreatedByCSReason || {});